import moment from "moment";
import ValoriModel from "stores/estimate/models/ValoriModel";
import FormatUtility from "utilities/FormatUtility";
import IAction from "../../models/IAction";
import BaseReducer from "../../utilities/BaseReducer";
import SimulazioneAction from "./SimulazioneAction";
import AssicurazioneModel from "./models/AssicurazioneModel";
import CommissioniBancaSegnalanteFormModel from "./models/CommissioniBancaSegnalanteFormModel";
import DashboardSimulazioneFormModel from "./models/DashboardSimulazioneFormModel";
import ISimulazioneState from "./models/ISimulazioneState";
import OneriFormModel from "./models/OneriFormModel";
import ProdottoLightModel from "./models/ProdottoLightModel";
import ProvvigioniComissioniFormModel from "./models/ProvvigioniComissioniFormModel";
import RichiestaCedibileModel from "./models/RichiestaCedibileModel";
import SimulazioneCreditoNetFormModel from "./models/SimulazioneCreditoNetFormModel";
import SimulazioneCreditoNetTableModel from "./models/SimulazioneCreditoNetTableModel";
import SimulazioneExtendedModel from "./models/SimulazioneExtendedModel";
import SimulazioneLightModel from "./models/SimulazioneLightModel";
import SimulazioneModel from "./models/SimulazioneModel";
import SimulazioneRichiestaCedibilitaTableModel from "./models/SimulazioneRichiestaCedibilitaTableModel";
import SimulazioneStepOneCollapseModel from "./models/SimulazioneStepOneCollapseModel";
import SimulazioneStepOneFormModel from "./models/SimulazioneStepOneFormModel";
import SimulazioneStepThreeFormModel from "./models/SimulazioneStepThreeFormModel";
import SimulazioneStepTwoFormModel from "./models/SimulazioneStepTwoFormModel";
import SpeseIstruttoriaFormModel from "./models/SpeseIstruttoriaFormModel";
import TaegTegModel from "./models/TaegTegModel";
import TanBaseFormModel from "./models/TanBaseFormModel";
import VersionSpendingReview from "./models/VersionSpendingReviewModel";
import DettaglioCreditoNetModel from "./models/creditoNet/DettaglioCreditoNetModel";
import DettaglioRichiestaCedibilitaModel from "./models/richiestaCedibilita/DettaglioRichiestaCedibilitaModel";
import MailCertificataModel from "./models/MailCertificataModel";

export default class SimulazioneReducer extends BaseReducer<ISimulazioneState> {
    public readonly initialState: ISimulazioneState = {
        simulazioniItems: [],
        step: 0,
        dashboardSimulazioneForm: new DashboardSimulazioneFormModel({}),
        formStep1: new SimulazioneStepOneFormModel({
            dataDecorrenza: FormatUtility.getEffectiveDate(),
        }),
        collapseStep1: new SimulazioneStepOneCollapseModel({}),
        prodottoSelected: new SimulazioneExtendedModel({}),
        assicurazioneSelected: new AssicurazioneModel({}),
        formStep2: new SimulazioneStepTwoFormModel({}),
        richiestaCedibileForm: {
            tipoDocumento: "",
            ente: "",
            codiceSede: undefined,
            codiceCategoriaPensione: undefined,
            noCertificatoPensione: undefined,
            noDocumento: "",
            codiceFiscale: "",
            privacyInps: "No",
        } as RichiestaCedibileModel,
        simulazioni: [],
        creditoNetForm: {
            date: moment().format("DD/MM/YYYY"),
            taxCode: "",
            monthSalary: "",
            idSalary: "",
            withholdingCode: "XA2",
            agencyCode: "xxxxxx",
            idUser: sessionStorage.getItem("member"),
        } as SimulazioneCreditoNetFormModel,
        prodottiLight: [],
        creditoNetTabella: [],
        richiestaCedibilitaTabella: [],
        dettaglioCreditoNet: new DettaglioCreditoNetModel({}),
        simulazione: new SimulazioneModel({}),
        formStep3: new SimulazioneStepThreeFormModel({}),
        formProvvigioniComissioni: new ProvvigioniComissioniFormModel({}),
        formTanBase: new TanBaseFormModel({}),
        formOneri: new OneriFormModel({}),
        formSpeseIstruttoria: new SpeseIstruttoriaFormModel({}),
        openAvvisoPopup: false,
        setMailMandatory: false,
        setEsitamateDataMandatory: false,
        dettaglioRichiestaCedibilita: new DettaglioRichiestaCedibilitaModel({}),
        setBirthPlaceMandatory: true,
        setBirthForeignPlaceMandatory: false,
        setBirthCountyMandatory: false,
        resumedSimulazione: new SimulazioneModel({}),
        standardBankCommissions: new ValoriModel({}),
        standardAgentCommissions: new ValoriModel({}),
        formCommissioniBancaSegnalante: new CommissioniBancaSegnalanteFormModel({}),
        versionSpendingReview: new VersionSpendingReview({}),
        stepDiProvenienza: undefined,
        idCertificazioneMail: undefined,
        verificaMailStatus: false,
        sendCertificazione: false,
    };

    public [SimulazioneAction.REQUEST_SIMULAZIONE_SIMULAZIONI_LIST_GET_FINISHED](
        state: ISimulazioneState,
        action: IAction<SimulazioneLightModel[]>
    ): ISimulazioneState {
        return {
            ...state,
            simulazioniItems: action.payload!,
        };
    }

    public [SimulazioneAction.REQUEST_SIMULAZIONE_STEP_SET_FINISHED](
        state: ISimulazioneState,
        action: IAction<number>
    ): ISimulazioneState {
        return {
            ...state,
            step: action.payload!,
        };
    }

    public [SimulazioneAction.REQUEST_SIMULAZIONE_FORM_DASHBOARD_SET_FINISHED](
        state: ISimulazioneState,
        action: IAction<DashboardSimulazioneFormModel>
    ): ISimulazioneState {
        return {
            ...state,
            dashboardSimulazioneForm: action.payload!,
        };
    }

    public [SimulazioneAction.REQUEST_SIMULAZIONE_FORM_STEP_ONE_SET_FINISHED](
        state: ISimulazioneState,
        action: IAction<SimulazioneStepOneFormModel>
    ): ISimulazioneState {
        return {
            ...state,
            formStep1: action.payload!,
        };
    }

    public [SimulazioneAction.REQUEST_SIMULAZIONE_FORM_STEP_TWO_SET_FINISHED](
        state: ISimulazioneState,
        action: IAction<SimulazioneStepTwoFormModel>
    ): ISimulazioneState {
        return {
            ...state,
            formStep2: action.payload!,
        };
    }

    public [SimulazioneAction.REQUEST_SIMULAZIONE_COLLAPSE_STEP_ONE_SET_FINISHED](
        state: ISimulazioneState,
        action: IAction<SimulazioneStepOneCollapseModel>
    ): ISimulazioneState {
        return {
            ...state,
            collapseStep1: action.payload!,
        };
    }

    public [SimulazioneAction.REQUEST_SIMULAZIONE_RESET_DATI_FINISHED](
        state: ISimulazioneState,
        action: IAction<any>
    ): ISimulazioneState {
        return {
            ...this.initialState,
        };
    }

    public [SimulazioneAction.REQUEST_SIMULAZIONE_SET_PRODOTTO_SELECTED_FINISHED](
        state: ISimulazioneState,
        action: IAction<SimulazioneExtendedModel>
    ): ISimulazioneState {
        const errors = action?.payload?.simulazione?.errors;
        const warnings = action?.payload?.simulazione?.warnings;
        const hasErrorsOrWarnings = (errors && errors.length > 0) || (warnings && warnings.length > 0);

        const formTanBase = new TanBaseFormModel({
            tanBase: FormatUtility.numberWithSeparators(action.payload?.simulazione?.tanBase || 0, 0.01).toString(),
            idMotivCambioTan: action.payload?.simulazione?.idMotivCambioTan,
        });

        const formOneri = new OneriFormModel({
            oneri: FormatUtility.numberWithSeparators(action.payload?.simulazione?.charges || 0, 0.01).toString(),
        });

        //const bankCommissionsAmount = action.payload?.simulazione?.bankCommissions.amount || 0;
        // const agentCommissionsAmount = action.payload?.simulazione?.agentCommissions.amount || 0;
        // const totalAmount = bankCommissionsAmount + agentCommissionsAmount;
        // const bankCommissionsPercentage = (bankCommissionsAmount / totalAmount) * 100;
        // const agentCommissionsPercentage = (agentCommissionsAmount / totalAmount) * 100;

        const formProvvigioniComissioni = new ProvvigioniComissioniFormModel({
            bankCommissionsPercentage: FormatUtility.numberWithSeparators(
                action.payload?.simulazione?.bankCommissions.percentage || 0,
                0.01
            ).toString(),
            bankCommissionsAmount: FormatUtility.numberWithSeparators(
                action.payload?.simulazione?.bankCommissions.amount || 0,
                0.01
            ).toString(),
            agentCommissionsPercentage: FormatUtility.numberWithSeparators(
                action.payload?.simulazione?.agentCommissions.percentage || 0,
                0.01
            ).toString(),
            agentCommissionsAmount: FormatUtility.numberWithSeparators(
                action.payload?.simulazione?.agentCommissions.amount || 0,
                0.01
            ).toString(),
            maxTotalPercentage: 100, // prodottoSelected.simulazione?.maxTotalCommissions?.percentage || 0,
            maxTotalAmount: action.payload?.simulazione?.maxTotalCommissions?.amount || 0,
        });

        const formSpeseIstruttoria = new SpeseIstruttoriaFormModel({
            preliminaryCostsPercentage: FormatUtility.numberWithSeparators(
                action.payload?.simulazione?.preliminaryCosts.percentage || 0,
                0.01
            ).toString(),
            preliminaryCostsAmount: FormatUtility.numberWithSeparators(
                action.payload?.simulazione?.preliminaryCosts.amount || 0,
                0.01
            ).toString(),
            minValue: action.payload?.simulazione?.preliminaryCosts.minValue,
            maxValue: action.payload?.simulazione?.preliminaryCosts.maxValue,
        });

        const formCommissioniBancaSegnalante = new CommissioniBancaSegnalanteFormModel({
            reportingBankCommissionsPercentage: FormatUtility.numberWithSeparators(
                action.payload?.simulazione?.reportingBankCommissions.percentage || 0,
                0.01
            ).toString(),
            reportingBankCommissionsAmount: FormatUtility.numberWithSeparators(
                action.payload?.simulazione?.reportingBankCommissions.amount || 0,
                0.01
            ).toString(),
        });

        const standardBankCommissionsFromSelecetedProdotto = action.payload?.simulazione?.bankCommissions!;
        const standardAgentCommissionsFromSelecetedProdotto = action.payload?.simulazione?.agentCommissions!;

        //Empty Taeg e Teg on product change
        const taegTeg = new TaegTegModel({});

        return {
            ...state,
            prodottoSelected: action.payload!,
            openAvvisoPopup: hasErrorsOrWarnings || false,
            formTanBase: formTanBase,
            formOneri: formOneri,
            formProvvigioniComissioni: formProvvigioniComissioni,
            formSpeseIstruttoria: formSpeseIstruttoria,
            simulazione: new SimulazioneModel({}),
            standardBankCommissions: standardBankCommissionsFromSelecetedProdotto,
            standardAgentCommissions: standardAgentCommissionsFromSelecetedProdotto,
            taegTeg: taegTeg,
            formCommissioniBancaSegnalante: formCommissioniBancaSegnalante,
        };
    }

    public [SimulazioneAction.REQUEST_SIMULAZIONE_SET_ASSICURAZIONE_SELECTED_FINISHED](
        state: ISimulazioneState,
        action: IAction<AssicurazioneModel>
    ): ISimulazioneState {
        return {
            ...state,
            assicurazioneSelected: action.payload!,
            simulazione: new SimulazioneModel({}), //12/07/2023 - resettata la simulazione nello state per svuotare campi (teg & taeg) - vedi CLCS-1998372
        };
    }

    public [SimulazioneAction.REQUEST_SIMULAZIONE_RICHIESTA_CEDIBILE_FORM_SET_FINISHED](
        state: ISimulazioneState,
        action: IAction<RichiestaCedibileModel>
    ): ISimulazioneState {
        return {
            ...state,
            richiestaCedibileForm: action.payload!,
        };
    }

    public [SimulazioneAction.REQUEST_SIMULAZIONE_SIMULATE_FINISHED](
        state: ISimulazioneState,
        action: IAction<SimulazioneModel>
    ): ISimulazioneState {
        const prodottoLight = state.prodottiLight.find(
            (item: ProdottoLightModel) => Number(item.key) === action.payload?.idProduct
        ) as ProdottoLightModel;

        const simulazione = action.payload;
        const resumedSimulazione = state.resumedSimulazione;

        // creo un nuovo oggetto esteso contenente il prodotto e la nuova simulazione
        let simulazioneExtendedNew = new SimulazioneExtendedModel({
            prodotto: prodottoLight,
            simulazione: simulazione,
        });

        // recupero le simulazioni presenti nello state
        let simulazioneExtendedState = [...(state.simulazioniExtended || [])];

        // Verifico che nello state non sia già presente un oggetto esteso contenente una simulazione con lo stesso id prodotto
        // Se esiste, aggiorno la simulazione precedente con la nuova simulazione appena ottenuta
        // N.B. Questa logica è stata aggiunta per poter gestire le simulazioni in funzione dei listini assicurativi senza stravolgere l'attuale funzionamento
        // attualmente non è possibile avere più simulazioni associate allo stesso prodotto

        const productFoundIndex = simulazioneExtendedState.findIndex(
            (item) => item.prodotto?.key === simulazioneExtendedNew.prodotto?.key
        );
        if (productFoundIndex >= 0) {
            const simulazioneExtendedStateTemp = simulazioneExtendedState.map((c, i) => {
                if (i === productFoundIndex) {
                    return simulazioneExtendedNew;
                } else {
                    return c;
                }
            });
            simulazioneExtendedState = simulazioneExtendedStateTemp;
        } else {
            simulazioneExtendedState = [...(simulazioneExtendedState || []), simulazioneExtendedNew];
        }
        const proddotiExtendedList = simulazioneExtendedState;

        let prodottoSelectedFirst = proddotiExtendedList[0];
        let prodottoSelectedFromSimulazioneSalvata: SimulazioneExtendedModel | undefined;
        let prodottoSelected: SimulazioneExtendedModel;

        if (state.simulazione.idProduct) {
            prodottoSelectedFromSimulazioneSalvata = proddotiExtendedList.find(
                (item: SimulazioneExtendedModel) => item.simulazione?.idProduct === state.simulazione?.idProduct
            );
        }

        if (prodottoSelectedFromSimulazioneSalvata) {
            prodottoSelected = prodottoSelectedFromSimulazioneSalvata;
        } else if (!state.prodottoSelected.prodotto) {
            // se sto effettuando la simulazione per la prima volta, il prodotto selezionato sarà il primo della lista
            prodottoSelected = prodottoSelectedFirst;
        } else if (
            (simulazione!.idInsurancePriceListRc != 0 &&
                simulazione!.idInsurancePriceListRv != 0 &&
                simulazione?.idRequestType != 2) ||
            (simulazione!.idInsurancePriceListRv != 0 && simulazione?.idRequestType == 2)
        ) {
            //se uguale a CQP si controlla solo Rischio Vita - CQS o DLG entrambe le assicurazioni
            // altrimenti se mi trovo in una delle simulazioni successive (escluse le prime fittizie fatte senza passare i listini assicurativi)
            prodottoSelected = simulazioneExtendedNew;
        } else {
            // se è una delle simulazioni fittizie eseguite al primo caricamento, lascio il prodotto selezionato presente nello state (ovvero il primo)
            prodottoSelected = state.prodottoSelected;
        }

        //Se mi trovo nel caso di una simulazione già salvata e quindi sia il prodotto della simulazione che i listini assicurativi coincidono,
        //mostro i dati della simulazione salvata
        if (resumedSimulazione.idSimulation !== 0) {
            console.log("------->  " + resumedSimulazione.idSimulation);
            prodottoSelected = new SimulazioneExtendedModel({
                ...prodottoSelected,
                simulazione: resumedSimulazione,
            });
        }

        const formStep1 = new SimulazioneStepOneFormModel({
            ...state.formStep1,
            // dataDecorrenza: prodottoSelected?.simulazione?.effectiveDate
            //     ? FormatUtility.dateInGivenFormat(prodottoSelected?.simulazione?.effectiveDate, DateFormatEnum.ITA_DATE)
            //     : FormatUtility.dateInGivenFormat(new Date(), DateFormatEnum.ITA_DATE),
        });

        //const bankCommissionsAmount = prodottoSelected?.simulazione?.bankCommissions.amount || 0;
        //const agentCommissionsAmount = prodottoSelected?.simulazione?.agentCommissions.amount || 0;
        //const totalAmount = bankCommissionsAmount + agentCommissionsAmount;
        //const bankCommissionsPercentage = prodottoSelected?.simulazione?.bankCommissions.percentage || 0;
        //const agentCommissionsPercentage = prodottoSelected?.simulazione?.agentCommissions.percentage || 0;

        const formProvvigioniComissioni = new ProvvigioniComissioniFormModel({
            bankCommissionsPercentage: FormatUtility.numberWithSeparators(
                prodottoSelected?.simulazione?.bankCommissions.percentage || 0,
                0.01
            ).toString(),
            bankCommissionsAmount: FormatUtility.numberWithSeparators(
                prodottoSelected?.simulazione?.bankCommissions.amount || 0,
                0.01
            ).toString(),
            agentCommissionsPercentage: FormatUtility.numberWithSeparators(
                prodottoSelected?.simulazione?.agentCommissions.percentage || 0,
                0.01
            ).toString(),
            agentCommissionsAmount: FormatUtility.numberWithSeparators(
                prodottoSelected?.simulazione?.agentCommissions.amount || 0,
                0.01
            ).toString(),
            maxTotalPercentage: 100, // prodottoSelected.simulazione?.maxTotalCommissions?.percentage || 0,
            maxTotalAmount: prodottoSelected?.simulazione?.maxTotalCommissions?.amount || 0,
        });

        const formSpeseIstruttoria = new SpeseIstruttoriaFormModel({
            preliminaryCostsPercentage: FormatUtility.numberWithSeparators(
                prodottoSelected?.simulazione?.preliminaryCosts.percentage || 0,
                0.01
            ).toString(),
            preliminaryCostsAmount: FormatUtility.numberWithSeparators(
                prodottoSelected?.simulazione?.preliminaryCosts.amount || 0,
                0.01
            ).toString(),
            minValue: prodottoSelected?.simulazione?.preliminaryCosts.minValue,
            maxValue: prodottoSelected?.simulazione?.preliminaryCosts.maxValue,
        });

        const formTanBase = new TanBaseFormModel({
            tanBase: FormatUtility.numberWithSeparators(prodottoSelected?.simulazione?.tanBase || 0, 0.01).toString(),
            idMotivCambioTan: resumedSimulazione.idMotivCambioTan,
        });

        const formOneri = new OneriFormModel({
            oneri: FormatUtility.numberWithSeparators(prodottoSelected?.simulazione?.charges || 0, 0.01).toString(),
        });

        const errors = simulazione?.errors;
        const warnings = simulazione?.warnings;
        const hasErrorsOrWarnings = (errors && errors.length > 0) || (warnings && warnings.length > 0);

        const standardBankCommissionsFromSimulate = simulazione?.bankCommissions!;
        const standardAgentCommissionsFromSimulate = simulazione?.agentCommissions!;

        const taegTeg = new TaegTegModel({
            taeg: prodottoSelected.simulazione?.taeg,
            teg: prodottoSelected.simulazione?.teg,
        });
        if (resumedSimulazione.idSimulation !== 0 || !state.prodottoSelected.prodotto) {
            return {
                ...state,
                simulazioni: [...state.simulazioni, simulazione!],
                resumedSimulazione: simulazione && state.stepDiProvenienza !== "3" ? simulazione : resumedSimulazione,
                simulazioniExtended: simulazioneExtendedState,
                prodottoSelected: prodottoSelected,
                formProvvigioniComissioni: formProvvigioniComissioni,
                formTanBase: formTanBase,
                formOneri: formOneri,
                formSpeseIstruttoria: formSpeseIstruttoria,
                formStep1: formStep1,
                openAvvisoPopup: hasErrorsOrWarnings || false,
                standardBankCommissions:
                    prodottoSelected.simulazione?.bankCommissions || standardBankCommissionsFromSimulate,
                standardAgentCommissions:
                    prodottoSelected.simulazione?.agentCommissions || standardAgentCommissionsFromSimulate,
                taegTeg: taegTeg,
            };
        } else {
            return {
                ...state,
                simulazioni: [...state.simulazioni, simulazione!],
                resumedSimulazione: simulazione && state.stepDiProvenienza !== "3" ? simulazione : resumedSimulazione,
                simulazioniExtended: simulazioneExtendedState,
                prodottoSelected: new SimulazioneExtendedModel({
                    ...state.prodottoSelected,
                    simulazione: new SimulazioneModel({
                        ...state.prodottoSelected.simulazione,
                        guid: simulazione?.guid,
                    }),
                }),
                openAvvisoPopup: hasErrorsOrWarnings || false,
                taegTeg: taegTeg,
            };
        }
    }

    public [SimulazioneAction.REQUEST_SIMULAZIONE_PRODOTTI_LIGHT_GET_FINISHED](
        state: ISimulazioneState,
        action: IAction<ProdottoLightModel[]>
    ): ISimulazioneState {
        return {
            ...state,
            prodottiLight: action.payload!,
        };
    }

    public [SimulazioneAction.REQUEST_SIMULAZIONE_ASSICURAZIONI_GET_FINISHED](
        state: ISimulazioneState,
        action: IAction<AssicurazioneModel[]>
    ): ISimulazioneState {
        const defaultAsscicurazioneSelected = action.payload![0];
        let assicurazioneSelectedFromSimulazioneSalvata: AssicurazioneModel | undefined;
        let assicurazioneSelected: AssicurazioneModel;

        if (
            state.simulazione.idInsuranceRc &&
            state.simulazione.idInsuranceRv &&
            state.simulazione.idRequestType !== 2
        ) {
            assicurazioneSelectedFromSimulazioneSalvata = action.payload?.find(
                (item: AssicurazioneModel) =>
                    item.creditRisk?.idInsurance === state.simulazione.idInsuranceRc &&
                    item.creditRisk.idInsurancePriceList === state.simulazione.idInsurancePriceListRc &&
                    item.lifeRisk?.idInsurance === state.simulazione.idInsuranceRv &&
                    item.lifeRisk?.idInsurancePriceList === state.simulazione.idInsurancePriceListRv
            );
        }
        //solo in caso di CQP
        if (state.simulazione.idInsuranceRv && state.simulazione.idRequestType === 2) {
            assicurazioneSelectedFromSimulazioneSalvata = action.payload?.find(
                (item: AssicurazioneModel) =>
                    item.lifeRisk?.idInsurance === state.simulazione.idInsuranceRv &&
                    item.lifeRisk?.idInsurancePriceList === state.simulazione.idInsurancePriceListRv
            );
        }

        if (assicurazioneSelectedFromSimulazioneSalvata) {
            assicurazioneSelected = assicurazioneSelectedFromSimulazioneSalvata;
        } else {
            assicurazioneSelected = defaultAsscicurazioneSelected;
        }

        return {
            ...state,
            assicurazioniExtended: action.payload!,
            assicurazioneSelected: assicurazioneSelected,
        };
    }

    public [SimulazioneAction.SIMULAZIONE_RESET_PRODOTTI](
        state: ISimulazioneState,
        action: IAction<string>
    ): ISimulazioneState {
        return {
            ...state,
            simulazioniExtended: this.initialState.simulazioniExtended,
            prodottoSelected: new SimulazioneExtendedModel({}),
            openAvvisoPopup: false,
            stepDiProvenienza: action.payload,
        };
    }

    public [SimulazioneAction.SIMULAZIONE_SET_STEP](
        state: ISimulazioneState,
        action: IAction<string>
    ): ISimulazioneState {
        return {
            ...state,
            stepDiProvenienza: action.payload,
        };
    }

    public [SimulazioneAction.SIMULAZIONE_RESET_ASSICURAZIONI](
        state: ISimulazioneState,
        action: IAction<any>
    ): ISimulazioneState {
        return {
            ...state,
            assicurazioniExtended: this.initialState.assicurazioniExtended,
            assicurazioneSelected: new AssicurazioneModel({}),
            simulazione: new SimulazioneModel({}), //12/07/2023 - resettata la simulazione nello state per svuotare campi (teg & taeg) - vedi CLCS-1998372
        };
    }

    public [SimulazioneAction.REQUEST_SIMULAZIONE_CALCULATE_TAEG_TEG_FINISHED](
        state: ISimulazioneState,
        action: IAction<TaegTegModel>
    ): ISimulazioneState {
        return {
            ...state,
            taegTeg: action.payload!,
        };
    }

    public [SimulazioneAction.REQUEST_SIMULAZIONE_SALVA_FINISHED](
        state: ISimulazioneState,
        action: IAction<SimulazioneModel>
    ): ISimulazioneState {
        return {
            ...state,
            simulazione: action.payload!,
        };
    }

    public [SimulazioneAction.SIMULAZIONE_SET_SIMULAZIONE_SALVATA](
        state: ISimulazioneState,
        action: IAction<SimulazioneModel>
    ): ISimulazioneState {
        return {
            ...state,
            simulazione: action.payload!,
        };
    }

    public [SimulazioneAction.REQUEST_SIMULAZIONE_UPDATE_FINISHED](
        state: ISimulazioneState,
        action: IAction<SimulazioneModel>
    ): ISimulazioneState {
        return {
            ...state,
            simulazione: action.payload!,
        };
    }

    public [SimulazioneAction.REQUEST_SIMULAZIONE_FORM_STEP_THREE_SET_FINISHED](
        state: ISimulazioneState,
        action: IAction<SimulazioneStepThreeFormModel>
    ): ISimulazioneState {
        return {
            ...state,
            formStep3: action.payload!,
        };
    }

    public [SimulazioneAction.SIMULAZIONE_SET_FORM_PROVVIGIONI_COMISSIONI](
        state: ISimulazioneState,
        action: IAction<ProvvigioniComissioniFormModel>
    ): ISimulazioneState {
        return {
            ...state,
            formProvvigioniComissioni: action.payload!,
        };
    }

    public [SimulazioneAction.SIMULAZIONE_SET_FORM_TAN_BASE](
        state: ISimulazioneState,
        action: IAction<TanBaseFormModel>
    ): ISimulazioneState {
        return {
            ...state,
            formTanBase: action.payload!,
        };
    }

    public [SimulazioneAction.SIMULAZIONE_SET_FORM_ONERI](
        state: ISimulazioneState,
        action: IAction<OneriFormModel>
    ): ISimulazioneState {
        return {
            ...state,
            formOneri: action.payload!,
        };
    }

    public [SimulazioneAction.SIMULAZIONE_SET_FORM_SPESE_ISTRUTTORIA](
        state: ISimulazioneState,
        action: IAction<SpeseIstruttoriaFormModel>
    ): ISimulazioneState {
        return {
            ...state,
            formSpeseIstruttoria: action.payload!,
        };
    }

    public [SimulazioneAction.SIMULAZIONE_SET_FORM_COMISSIONI_BANCA_SEGNALANTE](
        state: ISimulazioneState,
        action: IAction<CommissioniBancaSegnalanteFormModel>
    ): ISimulazioneState {
        return {
            ...state,
            formCommissioniBancaSegnalante: action.payload!,
        };
    }

    public [SimulazioneAction.REQUEST_SIMULAZIONE_RICALCOLA_FINISHED](
        state: ISimulazioneState,
        action: IAction<SimulazioneModel>
    ): ISimulazioneState {
        //TODO: recheck commissions if calculation is wrong
        const bankCommissions = action.payload?.bankCommissions;
        const agentCommissions = action.payload?.agentCommissions;
        const maxTotalCommissions = action.payload?.maxTotalCommissions;
        const valoriStandard = {
            ...action.payload!,
            bankCommissions,
            agentCommissions,
            maxTotalCommissions,
        };
        const standardSimulazione = new SimulazioneModel(valoriStandard);
        const simulazione = new SimulazioneModel(action.payload!);
        const prodottoLight = state.prodottoSelected.prodotto || new ProdottoLightModel({});
        const prodottoSelected = new SimulazioneExtendedModel({
            prodotto: prodottoLight,
            simulazione: standardSimulazione,
        });

        //const bankCommissionsAmount = simulazione?.bankCommissions.amount || 0;
        //const agentCommissionsAmount = simulazione?.agentCommissions.amount || 0;
        //const totalAmount = bankCommissionsAmount + agentCommissionsAmount;
        const bankCommissionsPercentage = simulazione?.bankCommissions.percentage || 0;
        const agentCommissionsPercentage = simulazione?.agentCommissions.percentage || 0;

        const formProvvigioniComissioni = new ProvvigioniComissioniFormModel({
            bankCommissionsPercentage: FormatUtility.numberWithSeparators(bankCommissionsPercentage, 0.01).toString(),
            bankCommissionsAmount: FormatUtility.numberWithSeparators(
                simulazione?.bankCommissions.amount || 0,
                0.01
            ).toString(),
            agentCommissionsPercentage: FormatUtility.numberWithSeparators(agentCommissionsPercentage, 0.01).toString(),
            agentCommissionsAmount: FormatUtility.numberWithSeparators(
                simulazione?.agentCommissions.amount || 0,
                0.01
            ).toString(),
            maxTotalPercentage: 100, //standardSimulazione?.maxTotalCommissions.percentage || 0,
            maxTotalAmount: standardSimulazione?.maxTotalCommissions.amount || 0,
        });

        const formTanBase = new TanBaseFormModel({
            tanBase: FormatUtility.numberWithSeparators(simulazione.tan || 0, 0.01).toString(),
            idMotivCambioTan: simulazione.idMotivCambioTan,
        });

        const formOneri = new OneriFormModel({
            oneri: FormatUtility.numberWithSeparators(simulazione?.charges || 0, 0.01).toString(),
        });

        const formSpeseIstruttoria = new SpeseIstruttoriaFormModel({
            preliminaryCostsPercentage: FormatUtility.numberWithSeparators(
                simulazione?.preliminaryCosts.percentage || 0,
                0.01
            ).toString(),
            preliminaryCostsAmount: FormatUtility.numberWithSeparators(
                simulazione?.preliminaryCosts.amount || 0,
                0.01
            ).toString(),
            minValue: simulazione?.preliminaryCosts.minValue,
            maxValue: simulazione?.preliminaryCosts.maxValue,
        });

        const errors = simulazione?.errors;
        const warnings = simulazione?.warnings;
        const hasErrorsOrWarnings = (errors && errors.length > 0) || (warnings && warnings.length > 0);

        //Empty Taeg e Teg on ricalcola
        const taegTeg = new TaegTegModel({});

        return {
            ...state,
            prodottoSelected: prodottoSelected,
            resumedSimulazione: prodottoSelected.simulazione!,
            formProvvigioniComissioni: formProvvigioniComissioni,
            formTanBase: formTanBase,
            formOneri: formOneri,
            formSpeseIstruttoria: formSpeseIstruttoria,
            openAvvisoPopup: hasErrorsOrWarnings || false,
            taegTeg: taegTeg,
        };
    }

    public [SimulazioneAction.SIMULAZIONE_SET_AVVISO_POPUP](
        state: ISimulazioneState,
        action: IAction<boolean>
    ): ISimulazioneState {
        return {
            ...state,
            openAvvisoPopup: action.payload!,
        };
    }

    public [SimulazioneAction.REQUEST_SIMULAZIONE_SET_MAIL_MANDATORY](
        state: ISimulazioneState,
        action: IAction<boolean>
    ): ISimulazioneState {
        return {
            ...state,
            setMailMandatory: action.payload!,
        };
    }

    public [SimulazioneAction.REQUEST_SIMULAZIONE_SET_ESTIMATE_DATA_MANDATORY](
        state: ISimulazioneState,
        action: IAction<boolean>
    ): ISimulazioneState {
        return {
            ...state,
            setEsitamateDataMandatory: action.payload!,
        };
    }

    public [SimulazioneAction.REQUEST_SIMULAZIONE_FORM_CREDITO_NET_FINISHED](
        state: ISimulazioneState,
        action: IAction<SimulazioneCreditoNetFormModel>
    ): ISimulazioneState {
        return {
            ...state,
            creditoNetForm: action.payload!,
        };
    }

    public [SimulazioneAction.REQUEST_SIMULAZIONE_TABELLA_CREDITO_NET_FINISHED](
        state: ISimulazioneState,
        action: IAction<SimulazioneCreditoNetTableModel[]>
    ): ISimulazioneState {
        return {
            ...state,
            creditoNetTabella: action.payload!,
        };
    }

    public [SimulazioneAction.REQUEST_SIMULAZIONE_TABELLA_CREDITO_NET_RESET](
        state: ISimulazioneState,
        action: IAction<SimulazioneCreditoNetTableModel[]>
    ): ISimulazioneState {
        return {
            ...state,
            creditoNetTabella: [],
        };
    }

    public [SimulazioneAction.REQUEST_SIMULAZIONE_DETTAGLIO_CREDITO_NET_FINISHED](
        state: ISimulazioneState,
        action: IAction<DettaglioCreditoNetModel>
    ): ISimulazioneState {
        return {
            ...state,
            dettaglioCreditoNet: action.payload!,
        };
    }

    public [SimulazioneAction.REQUEST_SIMULAZIONE_RICHIESTA_CEDIBILITA_GET_FINISHED](
        state: ISimulazioneState,
        action: IAction<SimulazioneRichiestaCedibilitaTableModel[]>
    ): ISimulazioneState {
        return {
            ...state,
            richiestaCedibilitaTabella: action.payload!,
        };
    }

    public [SimulazioneAction.REQUEST_SIMULAZIONE_RICHIESTA_CEDIBILITA_GET_RESET](
        state: ISimulazioneState,
        action: IAction<SimulazioneRichiestaCedibilitaTableModel[]>
    ): ISimulazioneState {
        return {
            ...state,
            richiestaCedibilitaTabella: [],
        };
    }

    public [SimulazioneAction.REQUEST_SIMULAZIONE_DETTAGLIO_RICHIESTA_CEDIBILITA_GET_FINISHED](
        state: ISimulazioneState,
        action: IAction<DettaglioRichiestaCedibilitaModel>
    ): ISimulazioneState {
        return {
            ...state,
            dettaglioRichiestaCedibilita: action.payload!,
        };
    }

    public [SimulazioneAction.REQUEST_SIMULAZIONE_SET_BIRTH_PLACE_MANDATORY](
        state: ISimulazioneState,
        action: IAction<boolean>
    ): ISimulazioneState {
        return {
            ...state,
            setBirthPlaceMandatory: action.payload!,
        };
    }

    public [SimulazioneAction.REQUEST_SIMULAZIONE_SET_BIRTH_COUNTY_MANDATORY](
        state: ISimulazioneState,
        action: IAction<boolean>
    ): ISimulazioneState {
        return {
            ...state,
            setBirthCountyMandatory: action.payload!,
        };
    }

    public [SimulazioneAction.REQUEST_SIMULAZIONE_SET_BIRTH_FOREIGN_PLACE_MANDATORY](
        state: ISimulazioneState,
        action: IAction<boolean>
    ): ISimulazioneState {
        return {
            ...state,
            setBirthForeignPlaceMandatory: action.payload!,
        };
    }

    public [SimulazioneAction.REQUEST_SIMULAZIONE_RESUME_FINISHED](
        state: ISimulazioneState,
        action: IAction<SimulazioneModel>
    ): ISimulazioneState {
        return {
            ...state,
            resumedSimulazione: action.payload!,
            idCertificazioneMail: action.payload?.idCertificazioneMail,
        };
    }

    public [SimulazioneAction.REQUEST_SPENDING_REVIEW_FINISHED](
        state: ISimulazioneState,
        action: IAction<VersionSpendingReview>
    ): ISimulazioneState {
        return {
            ...state,
            versionSpendingReview: action.payload!,
        };
    }

    public [SimulazioneAction.REQUEST_CERTIFICA_MAIL_SET_FINISHED](
        state: ISimulazioneState,
        action: IAction<Number>
    ): ISimulazioneState {
        return {
            ...state,
            idCertificazioneMail: action.payload!,
            sendCertificazione: action.payload ? true : false,
        };
    }

    public [SimulazioneAction.REQUEST_CERTIFICA_MAIL_VALIDA_SET_FINISHED](
        state: ISimulazioneState,
        action: IAction<boolean>
    ): ISimulazioneState {
        return {
            ...state,
            verificaMailStatus: action.payload!,
            sendCertificazione: !action.payload,
        };
    }

    public [SimulazioneAction.RESUME_CERTIFICA_MAIL_SET_FINISHED](
        state: ISimulazioneState,
        action: IAction<MailCertificataModel>
    ): ISimulazioneState {
        return {
            ...state,
            verificaMailStatus: action.payload!.CERTIFICATA === "S",
        };
    }
    public [SimulazioneAction.RESET_CERTIFICA_MAIL_SET](state: ISimulazioneState): ISimulazioneState {
        return {
            ...state,
            verificaMailStatus: false,
            idCertificazioneMail: undefined,
        };
    }
}
